// headersConfig.js

export const headers = {

    
    name_of_selected_indicator_en: {
        label: "Indicator Name for DPO list (EN)",
        description: ""
    },
   
    name_of_selected_indicator_gr: {
        label: "Indicator Name for DPO list (GR)",
        description: ""
    },
 
    indicator_name: {
        label: "Indicator Descriptive Name (EN)",
        description: "The specific name used to identify the Key Performance Indicator (KPI)."
    },
    q4all_Ind_number: {
        label: "Q4All Indicator Number",
        description: "This will be an internal Number for indicators of 'Q4ALL Q4Alln.xxxx' with 4 digits."
    },
   
  
    shortlist_indicators:{
        label: "Type of Indicator (M, A)",
        description: "M-Manual; A-Automated;"
    },

 health_system_functions:{
        label: "HEALTH SYSTEM FUNCTIONS",
        description: ""
    },


 
    dimensions_of_Quality_QoCOfficeReport: {
        label: "ACCESS AND QUALITY OF CARE DIMENSIONS",
        description: `Classification according to QoCOfficeReport:
        Efficiency
        Access
        Equity
        User experience
        Effectiveness
        Safety`
     },

   dpo_org_source1: {
        label: "DPO Org Source1",
        description: ""
    },
  
    data_collection: {
        label: "data received",
        description: ""
    },
   
    calculation_Formula: {
        label: "Calculation Formula",
        description: "The mathematical equation or method used to compute the indicator’s value."
    },
    numerator: {
        label: "Numerator",
        description: "The top part of the calculation."
    },
    numerator_Definitions: {
        label: "Numerator Definitions",
        description: "Detailed explanation of what is counted in the numerator and how it is measured."
    },
    denominator: {
        label: "Denominator",
        description: "The bottom part of the calculation."
    },
    denominator_Definitions: {
        label: "Denominator Definitions",
        description: "Detailed explanation of what is included in the denominator and how it is measured."
    },
   

      unit_of_Measurement: {
        label: "Unit of Measurement",
        description: ""
    },
   
    periodicity: {
        label: "Periodicity (frequency of measurement)",
        description: "How often the data for this indicator is collected, e.g., weekly, monthly, quarterly, annually, etc."
    },
    

    
   
  };
  